import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/SocialAuth' /* webpackChunkName: "SocialAuth" */),
    import(
      './viewer/SocialAuth.controller' /* webpackChunkName: "SocialAuth" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('SocialAuth', UiTypes),
};

export default entry;
